const PROMOFLOW_BASE_API_URL = {
  promoflowUrl: import.meta.env.VITE_API_URL,
  authUrl: import.meta.env.VITE_AUTH_API_URL,
  menuUrl: import.meta.env.VITE_MENU_BUILD_API,
  registrationUrl: import.meta.env.VITE_REGISTRATION_API,
  restaurantUrl: import.meta.env.VITE_RESTAURANT_API,
  triggerUrl: import.meta.env.VITE_TRIGGER_URL,
  customerUrl: import.meta.env.VITE_RESTAURANT_API,
  promoflowV2Url: import.meta.env.VITE_PROMOFLOW_V2_API_URL,
} as const;

// API Endpoints
const ENDPOINTS = {
  // Auth
  login: `${PROMOFLOW_BASE_API_URL.authUrl}/login`,
  logout: `${PROMOFLOW_BASE_API_URL.authUrl}/logout`,
  forgotPassword: `${PROMOFLOW_BASE_API_URL.authUrl}/forgot-password`,
  resetPassword: `${PROMOFLOW_BASE_API_URL.authUrl}/reset-password`,
  createIso: `${PROMOFLOW_BASE_API_URL.authUrl}/createIso`,
  
  // Holidays & Events
  holidays: '/holidays/all',
  holidaysWithRestaurant: '/global_holidays',
  localEvents: '/local_events',
  
  // Market Intelligence - Table endpoints
  location_demographics: `${PROMOFLOW_BASE_API_URL.promoflowUrl}/location_demographics`,
  menu_suggestions: `${PROMOFLOW_BASE_API_URL.promoflowUrl}/menu_enhancement`,
  broad_competitors: `${PROMOFLOW_BASE_API_URL.promoflowUrl}/broad_competitors`,
  direct_competitors: `${PROMOFLOW_BASE_API_URL.promoflowUrl}/direct_competitors`,
  competitors_promotion: `${PROMOFLOW_BASE_API_URL.promoflowUrl}/competitors_promotion`,
  review_analysis: `${PROMOFLOW_BASE_API_URL.promoflowUrl}/review_analysis`,
  menu :  `${PROMOFLOW_BASE_API_URL.customerUrl}/menu`,
  
  // Content & Campaigns
  generated_content: `${PROMOFLOW_BASE_API_URL.triggerUrl}/generated_content/filter`,
  generated_ideas: '/generated_ideas',
  table_generated_ideas: `${PROMOFLOW_BASE_API_URL.promoflowUrl}/table/generated_ideas`,
  seasonal_suggestions: '/seasonal_suggestions',
  weekly_ideas: '/weekly_ideas',
  createPromotion: `${PROMOFLOW_BASE_API_URL.triggerUrl}/generated_content/trigger`,
  generateCampaign: `${PROMOFLOW_BASE_API_URL.triggerUrl}/generate-campaign`,
  schedule_campaign: `${PROMOFLOW_BASE_API_URL.triggerUrl}/schedule-campaign`,
  directCampaign: `${PROMOFLOW_BASE_API_URL.triggerUrl}/direct-campaign`,
  
  // Flyers
  table_flyers: `${PROMOFLOW_BASE_API_URL.triggerUrl}/flyers`,
  generateFlyer: '/flyers/generate',
  editFlyer: `${PROMOFLOW_BASE_API_URL.triggerUrl}/generated_content/edit`,
  updateFlyer: `${PROMOFLOW_BASE_API_URL.triggerUrl}/flyers`,
  getFlyer: `${PROMOFLOW_BASE_API_URL.triggerUrl}/flyers`,
  
  // Tasks & Prompts
  promoflow_tasks: '/promoflow_tasks/all',
  prompts: '/prompts/fetch',
  updatePrompts: '/prompts/upsert',
  
  // Restaurant & Registration
  updateRestaurant: '/updateRestaurant',
  restaurantView: `${PROMOFLOW_BASE_API_URL.restaurantUrl}/restaurant`,
  registration: `${PROMOFLOW_BASE_API_URL.registrationUrl}/promoflow/register`,
  menuBuilderRegister: `${PROMOFLOW_BASE_API_URL.menuUrl}/register`,
  
  // Social Media & Analytics
  facebookPost: '/facebook/post',
  social_media_analytics: `${PROMOFLOW_BASE_API_URL.triggerUrl}/social-media-posts`,
  
  // Workflow & Reports
  triggerWorkflow: `${PROMOFLOW_BASE_API_URL.triggerUrl}/workflow_runner/trigger`,
  generate_report: `${PROMOFLOW_BASE_API_URL.triggerUrl}/generate_report`,
  
  // Customers & Events
  customers: `${PROMOFLOW_BASE_API_URL.customerUrl}/customers`,
  eventMaster: `${PROMOFLOW_BASE_API_URL.triggerUrl}/event-master`,
  // Clover Integration
  cloverIntegrate: `${PROMOFLOW_BASE_API_URL.restaurantUrl}/integrate-clover`,
  cloverOauth: `${PROMOFLOW_BASE_API_URL.authUrl}/cloverIntegration?type=promoflow`,
  cloverMoniterUrl:  `${PROMOFLOW_BASE_API_URL.restaurantUrl}/task/monitor`,
  
  // Campaign Management (Promoflow V2)
  createCampaign: `${PROMOFLOW_BASE_API_URL.promoflowV2Url}/create/campaign`,
  getCampaign: (id: string) => `${PROMOFLOW_BASE_API_URL.promoflowV2Url}/campaign/${id}`,
  getAllCampaigns: `${PROMOFLOW_BASE_API_URL.promoflowV2Url}/campaigns`,
} as const;

export { PROMOFLOW_BASE_API_URL, ENDPOINTS };

export default ENDPOINTS;
